import BaseModulePlugins from '@/store/baseModule/plugins';
import makeListRequest from './makeQueryParams';
import registerInterventions from './interventions';
import techniciansModule from './module';

export default (store) => {
  store.registerModule(['technicians'], techniciansModule({ makeListRequest }));

  const basePlugin = new BaseModulePlugins({
    module: 'technicians',
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});
  registerInterventions(store);
};
